export const getTextWidth = (text, fontWeight, fontSize, fontFamily) => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  context.font = `${fontWeight} ${fontSize}px ${fontFamily}`
  const measure = context.measureText(text)
  return measure.width
}
